import { render, staticRenderFns } from "./DetalhamentoClickGrid.vue?vue&type=template&id=1100783a"
import script from "./DetalhamentoClickGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhamentoClickGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports